import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import { PassengerTypes, RAILCARD1617_CODE } from '../../constants/AppConstants';
import connectToStores from '../../helpers/connectToStores';
import SmartcardStore from '../../stores/SmartcardStore';
import FeatureFlagStore from '../../stores/FeatureFlagStore';
import OrderStore from '../../stores/OrderStore';
import InAppStore from '../../stores/InAppStore';
import AccountRailcard from '../../records/AccountRailcard';
import Search from '../../records/SeasonSearch';
import User from '../../records/User';
import Smartcard from '../../records/customer/Smartcard';
import CustomerActions from '../../actions/CustomerActions';
import Railcard1617Actions from '../../actions/Railcard1617Actions';
import Order from '../../records/Order';
import t from '../../lib/I18n';

import JourneySelector from './JourneySelector';
import SmartcardPassengerDetails from './../smartcard/PassengerDetails';
import SeasonStartDuration from '../seasonTicket/SeasonStartDuration';
import Passenger from '../seasonTicket/Passenger';
import Railcard1617Checkbox from '../seasonTicket/Railcard1617Checkbox';
import RailcardJobCentrePlusCheckbox from '../seasonTicket/RailcardJobCentrePlusCheckbox';
import Railcard1617Store from '../../stores/Railcard1617Store';
import SeasonDetailsVerticalRenderer from './SeasonDetailsVerticalRenderer';
import SmartcardInfo from "./smartcard/SmartcardInfo";
import UserStore from '../../stores/UserStore';
import Railcard1617Modal from '../seasonTicket/Railcard1617Modal';
import FeatureFlag from '../general/FeatureFlag';
import PromoDiscount from './PromoDiscount';

function _getStateFromStores() {
    const enableSmartcardMaintenance = FeatureFlagStore.get('enableSmartcardMaintenance'),
        enableSmartcard = FeatureFlagStore.get('enableSmartcard'),
        enableRailcard1617 = FeatureFlagStore.get('enableRailcard1617'),
        flashCheckbox = Railcard1617Store.get('flashCheckbox'),
        hasRailcard1617 = Railcard1617Store.hasRailcard1617Saver(),
        enableSmartcardTutorial = FeatureFlagStore.get('enableSmartcardTutorial'),
        enableSmartcardInfoInApp = FeatureFlagStore.get('enableSmartcardInfoInApp'),
        isRailcard1617Available = Railcard1617Store.get('isRailcard1617Available'),
        order = OrderStore.getCurrent(),
        shouldGetSmartcard = SmartcardStore.shouldGetSmartcard(),
        smartcard = SmartcardStore.get('smartcard'),
        smartcardFailure = SmartcardStore.get('smartcardFailure') ? true : false,
        user = UserStore.getCurrent(),
        isInApp = InAppStore.isInApp();

    return {
        enableRailcard1617,
        enableSmartcardMaintenance,
        enableSmartcard,
        enableSmartcardTutorial,
        enableSmartcardInfoInApp,
        flashCheckbox,
        hasRailcard1617,
        isRailcard1617Available,
        order,
        railcard1617: Railcard1617Store.getRailcard(),
        railcard1617Checked: Railcard1617Store.get('checked'),
        shouldGetSmartcard,
        smartcard,
        smartcardFailure,
        user,
        isInApp,
    };
}

export class SeasonDetailsForm extends React.PureComponent {
    static propTypes = {
        enableRailcard1617: PropTypes.bool.isRequired,
        enableSmartcardMaintenance: PropTypes.bool.isRequired,
        enableSmartcard: PropTypes.bool.isRequired,
        enableSmartcardTutorial: PropTypes.bool,
        enableSmartcardInfoInApp: PropTypes.bool,
        handleSearchChange: PropTypes.func,
        search: PropTypes.instanceOf(Search).isRequired,
        shouldGetSmartcard: PropTypes.bool.isRequired,
        smartcardFailure: PropTypes.bool.isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        smartcard: PropTypes.instanceOf(Smartcard),
        isInApp: PropTypes.bool,

        enableStationFinder: PropTypes.bool,
        flashCheckbox: PropTypes.bool,
        hasRailcard1617: PropTypes.bool,
        hideSmartcardInfo: PropTypes.bool,
        isRailcard1617Available: PropTypes.bool,
        order: PropTypes.instanceOf(Order),
        overlayStationResults: PropTypes.bool,
        railcard1617: PropTypes.instanceOf(AccountRailcard),
        railcard1617Checked: PropTypes.bool,
        railcardJobCentrePlusChecked: PropTypes.bool,
        renderer: PropTypes.func,
        searchAttempted: PropTypes.bool,
    };

    static defaultProps = {
        enableStationFinder: false,
        flashCheckbox: false,
        handleSearchChange: _.noop,
        hasRailcard1617: false,
        hideSmartcardInfo: false,
        isRailcard1617Available: false,
        order: null,
        overlayStationResults: false,
        railcard1617: null,
        renderer: SeasonDetailsVerticalRenderer
    };

    state = {
        search: this.props.search
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { search } = nextProps;
        this.setState({ search });
    }

    componentDidUpdate({
        hasRailcard1617: prevHasRailcard1617,
        user: prevUser,
        railcard1617Checked: prevRailcard1617Checked,
    }, {
        search: prevSearch,
    }) {
        const { hasRailcard1617, user, railcard1617Checked } = this.props;
        const { search } = this.state;

        if (!prevUser.isLoggedIn() && user.isLoggedIn()) {
            // Load the season railcards if user logs in
            _.defer(() => Railcard1617Actions.load(user));
        }

        if (search.railcardCode !== RAILCARD1617_CODE && !prevHasRailcard1617 && hasRailcard1617) {
            this._handleChangeFor('railcardCode')(RAILCARD1617_CODE);
        }

        if (prevRailcard1617Checked !== railcard1617Checked) {
            this._handleChangeFor('railcardCode')(railcard1617Checked ? RAILCARD1617_CODE : '');
        }

        if (
            prevSearch.passengerType !== search.passengerType &&
            search.passengerType !== PassengerTypes.ADULT
        ) {
            this._handleChangeFor('railcardJobCentrePlus')('');
            this._handleChangeFor('railcard1617')('');

            if (search.railcardCode !== '') {
                this._handleChangeFor('railcardCode')('');
            }
        }
    }

    componentDidMount() {
        if (!this._smartcardDisabled()) {
            CustomerActions.getSmartcard(this.props.user);
        }
    }

    _smartcardDisabled() {
        return this.props.enableSmartcardMaintenance;
    }

    _updateRailcard1617 = railcard1617 =>
        this._handleChangeFor('railcard1617')(railcard1617);

    _handleChangeFor = (key) => {
        return (value) => {
            this._handleSearchChange(this.state.search.set(key, value));
        };
    };

    _handleSearchChange = this.props.handleSearchChange;

    _handleStationChange = (stations) => {
        const search = this.state.search
            .set('origin', stations.origin)
            .set('destination', stations.destination);

        this._handleSearchChange(search);
    };

    _isViewingSmartcardFares() {
        const { smartcard, search } = this.props;
        return smartcard && smartcard.canSearchForProducts() && search.smartcard;
    }

    _renderPassenger() {
        return (!this._isViewingSmartcardFares()) && (
            <Passenger
                passengerType={ this.state.search.passengerType }
                onChange={ this._handleChangeFor('passengerType') }
            />
        );
    }

    _renderRailcardOptions() {
        const { enableRailcard1617, flashCheckbox, isRailcard1617Available, search, railcardJobCentrePlusChecked } = this.props;
        const isAdult = search.passengerType === PassengerTypes.ADULT;
        const { search: { railcard1617 } } = this.state;

        return enableRailcard1617 && (
            <section className={ classnames('booking__section', { 'booking__section--railcards': !this.props.search.smartcard }) }>
                <fieldset className="hidden-fieldset">
                    <legend>
                        <h2 className="railcards-heading">{ t('booking.railcards') }</h2>
                    </legend>

                    <Railcard1617Checkbox
                        disabled={ !isAdult }
                        flashCheckbox={ flashCheckbox }
                        onChange={ this._handleChangeFor('railcard1617') }
                        openModal={ this._handleRailcard1617ModalTextClick }
                        railcard1617={ search.railcard1617 }
                        railcardCode={ search.railcardCode }
                        user={ this.props.user }
                    />
                    {((!railcard1617 || (railcard1617 && !railcard1617.isPresent())) && !isRailcard1617Available) && (
                        <p className="railcard-16-17-warning text-sm text-light">
                            {t('booking.railcards.season.railcard1617.warning')}
                        </p>
                    )}

                    <RailcardJobCentrePlusCheckbox
                        disabled={ !isAdult }
                        onChange={ this._handleChangeFor('railcardJobCentrePlus') }
                        checked={ isAdult && railcardJobCentrePlusChecked || isAdult && search.railcardJobCentrePlus }
                    />
                </fieldset>
            </section>
        );
    }

    _renderSmartcardDetails() {
        return !this._smartcardDisabled() && this._isViewingSmartcardFares() && (
            <SmartcardPassengerDetails smartcard={ this.props.smartcard } />
        );
    }

    _handleRailcard1617ModalTextClick = () => {
        this.setState({ railcard1617ModalOpen: true });
    };

    _handleValidateRailcard = ({ railcardNumber, firstName, lastName, expiryDate }) => {
        Railcard1617Actions.validate({ railcardNumber, firstName, lastName, expiryDate });
    };

    _renderRailcardsWarning(showWarning) {
        return showWarning ? (<section className="booking__section text-sm text-light">
                {t('booking.railcards.season.warning')}
            </section>) : null;
    }

    _renderPromoDiscount () {
        return (
            <FeatureFlag name='enablePromoDiscount'>
                <PromoDiscount promoCode={this.props.search.promoCode} onChange={ this._handleChangeFor('promoCode') } order={this.props.order} />
            </FeatureFlag>
        );
    }

    render () {
        const { search } = this.state,
            {
                smartcard,
                enableStationFinder,
                overlayStationResults,
                renderer: FormRenderer,
                user,
                enableSmartcardTutorial,
                enableSmartcardInfoInApp,
                enableSmartcard,
                hideSmartcardInfo,
                isInApp,
                search: { railcard1617 },
                searchAttempted,
            } = this.props;

        return (
            <React.Fragment>
                {this.state.railcard1617ModalOpen &&
                    <Railcard1617Modal
                        onClose={ () => this.setState({ railcard1617ModalOpen: false }) }
                        onContinue={ this._handleValidateRailcard }
                        disableSuccessModal
                    />
                }
                <FormRenderer
                    smartcardInfo={ !hideSmartcardInfo && enableSmartcard && (isInApp ? enableSmartcardInfoInApp : true) &&
                        <SmartcardInfo
                            user={ user }
                            smartcard={ smartcard }
                            enableSmartcardTutorial={ enableSmartcardTutorial }
                        />
                    }
                    journeySelector={ (
                        <JourneySelector
                            enableStationFinder={ enableStationFinder }
                            season
                            searchErrors={ search.getValidationErrors() }
                            search={ search }
                            searchAttempted={ searchAttempted }
                            onChange={ this._handleStationChange }
                            overlayResults={ overlayStationResults }
                        />
                    ) }
                    passengers={ this._renderPassenger() }
                    railcardsWarning={ this._renderRailcardsWarning(false) } // no warning text required for now, so disabled
                    railcard1617={ this._renderRailcardOptions() }
                    dateTimePicker={ (
                        <SeasonStartDuration
                            search={ search }
                            searchAttempted={ searchAttempted }
                            smartcard={ smartcard }
                            railcard1617={ railcard1617 }
                            onChange={ this._handleSearchChange }
                            searchErrors={ search.getValidationErrors() } />
                        ) }
                    smartcardDetails={ this._renderSmartcardDetails() }
                    promoDiscount={ this._renderPromoDiscount() }
                />
            </React.Fragment>
            );
        }
}

export default connectToStores([OrderStore, FeatureFlagStore, SmartcardStore, Railcard1617Store, InAppStore], _getStateFromStores)(
    SeasonDetailsForm
);



// WEBPACK FOOTER //
// ./src/components/search/SeasonDetailsForm.js